module.exports = __webpack_public_path__ + "static/media/IntegrateSources.e36b3f87.svg";